import { Rank } from "./types";

function createDeck(): number[] {
  const deck: number[] = [];
  for (let suit = 0; suit < 4; suit++) {
    for (let r: Rank = 1; r <= 13; r++) {
      deck.push(suit * 16 + r);
    }
  }
  return deck;
}

export const createDecks = (seed: number): [number[], number[]] => {
  const deckZero: number[] = createDeck();
  const deckOne: number[] = createDeck();
  const r = splitmix32(seed >>> 0);
  const a = shuffle(deckZero, r);
  const b = shuffle(deckOne, r);
  return [a, b];
};

// shuffles the deck according to the seed provided.
export const shuffle = (cards: number[], getRand: () => number): number[] => {
  for (let i = cards.length - 1; i > 0; i--) {
    let r = getRand();
    const j = Math.floor((r / 4294967296) * (i + 1));
    [cards[i], cards[j]] = [cards[j], cards[i]];
  }
  return cards;
};
// random number generator with seed.
// Source - https://stackoverflow.com/a/47593316
// Posted by bryc, modified by community. See post 'Timeline' for change history
// Retrieved 2026-02-27, License - CC BY-SA 4.0

export function splitmix32(a: number): () => number {
  return function () {
    a |= 0;
    a = (a + 0x9e3779b9) | 0;
    let t = a ^ (a >>> 16);
    t = Math.imul(t, 0x21f0aaad);
    t = t ^ (t >>> 15);
    t = Math.imul(t, 0x735a2d97);
    return (t = t ^ (t >>> 15)) >>> 0;
  };
}
